/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import { StopEvent   } from './stop.event';
import { StopConsist } from './stop.consist';
import { Track       } from './track';

/**
 *
 * @class Stop
 *
 * @brief model for a train stopping at either a link or a decision point.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      November 2019
 *
 */
export class Stop {

  /** @var _id unique id for this stop */
  public             _id: number             = -1;

  /** @var _name human readable train name */
  public           _name: string             = '';

  /** @var _trainId unique id for the train this stop is for */
  public        _trainId: number             = -1;

  /** @var _depart P00DT12H00M00S, earliest departure time on DAY of departure at this location. */
  public         _depart: string             = 'P00DT00H00M00S';

  /** @var _clears_main True if train is clear during this stop or occupies whatever track it stops on */
  public    _clears_main: boolean            = false;

  /** @var _sequence order of the stops for this train */
  public       _sequence: number             = 0;

  /** @var _stops_on_link True = Stop time on link, False = Stop at DP */
  public  _stops_on_link: boolean            = false;

  /** @var _nth the zero based index for this item */
  public            _nth: number             = -1;

  /** @var _change the train parameters changes, if any */
  public         _change: StopConsist|null   = null;

  /** @var _events the activities at this stop */
  public         _events: StopEvent[]        = [];

  /** @var _tracks the set of tracks where this stop applies (valid links) */
  public         _tracks: Map<number, Track> = new Map<number, Track>();

  /** @brief standard constructor */
  constructor(
     id: number,
      n: string,
      t: number,
      d: string,
     cl: boolean,
    seq: number,
     sl: boolean,
      c: StopConsist|null,
    nth: number) {

    this._id            = id;
    this._name          = n;
    this._trainId       = t;
    this._depart        = d;
    this._clears_main   = cl;
    this._sequence      = seq;
    this._stops_on_link = sl;
    this._change        = c;
    this._nth           = nth;
  }
}
